// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import englishTranslation from "./en";
import spanishTranslation from "./es";
import catalanTranslation from "./cat";
import frenchTranslation from "./fr";
import tagalotTranslation from "./tl";
import galegoTranslation from "./gl";
import dutchTranslation from "./nl";
import basqueTranslation from "./eu";
export var votingPortalTranslations = {
    en: englishTranslation,
    es: spanishTranslation,
    cat: catalanTranslation,
    fr: frenchTranslation,
    tl: tagalotTranslation,
    gl: galegoTranslation,
    nl: dutchTranslation,
    eu: basqueTranslation,
};
